<template>
    <div>
        <h1>{{ title }}</h1>
        <div class="container my-3 pb-5">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    props: ['title'],
}
</script>
